import { render, staticRenderFns } from "./Personas.vue?vue&type=template&id=03c3d077&scoped=true"
import script from "./Personas.vue?vue&type=script&lang=js"
export * from "./Personas.vue?vue&type=script&lang=js"
import style0 from "./Personas.vue?vue&type=style&index=0&id=03c3d077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c3d077",
  null
  
)

export default component.exports